import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const ResetPasswordRoot = styled('form', {
  backgroundColor: '$secondary-100',
  padding: '$14 $3',
  minHeight: '100vh',

  '&': {
    [`${Stack}`]: {
      height: '100%',
    },
  },

  '@bp1': {
    padding: '$10 $3',
  },

  '@bp2': {
    $$headerHeight: '80px',
    padding: '$10 144px',
    paddingTop: 'calc($$headerHeight + $10)',
  },

  '@bp3': {
    maxWidth: 'calc($max/2)',
    '&': {
      [`${Stack}`]: {
        height: 'auto',
      },
    },
  },
})
